import * as React from "react";
function SvgIcDefault(props) {
  return <svg width="1em" height="1em" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g stroke="currentColor" strokeLinecap="round"><path d="M7 1.5v0A5.5 5.5 0 001.5 7v0A5.5 5.5 0 007 12.5v0A5.5 5.5 0 0012.5 7v0" /><path d="M12.5 2.5L7 8.5 4.5 6" strokeLinejoin="round" /></g></svg>;
}
export default SvgIcDefault;